<template>
    <transition name="fade">
        <div id="editor_trace" v-if="showEditor" @click.self="maskClickEvn">
            <div class="editor_trace">
                <div class="editor_trace1">
                    <div class="flex">
                        <span class="t-m-r-20">查看章节</span>
                        <textLoading v-if="streamStatus"></textLoading>
                    </div>
                    <img class="cursor_1" src="../assets/image/icon_close.png" alt="" @click="closePopup">
                </div>
                <main class="correct-main">
                    <div class="correct-left" v-if="chapter > 1">
                        <p class="correct-title"><span class="u-line-1" :title="prevTitle" style="display: block;flex: 1;">{{ prevTitle  }}</span><span style="color: red;">(上一章正文)</span></p>
                        <div v-html="prevContent" class="yw-content"></div>
                    </div>
                    <div class="correct-left">
                        <p class="correct-title"><span class="u-line-1" :title="title" style="display: block;flex: 1;">{{ title  }}</span><span style="color: red;">(当前正文)</span></p>
                        <div v-html="content" class="yw-content"></div>
                    </div>
                </main>
            </div>
        </div>
    </transition>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
import editBox from '@/components/edit_box.vue' // 文本编辑框
import textLoading from '@/components/text_loading.vue';
import MarkdownRenderer from '@/components/global/MarkdownRenderer.vue'
import api from '@/api/api';
import lNApi from '@/api/longNovel';
import { marked } from 'marked'
export default {
    components: {
        editBox, textLoading, MarkdownRenderer
    },
    props: {
        maskClick: {
            type: Boolean,
            default: true
        },
        length: {
            type: String,
            default: '短'
        }
    },
    data() {
        return {
            showEditor: false,
            activeName: '1',
            currectText: `1.检查本章正文与上一章正文是否存在内容重复。\n2.确认本章正文开头与上一章结尾的情节、逻辑是否自然衔接，过渡是否流畅。\n3.排查本章正文内是否存在剧情、语句或情节的重复表述。\n4.审视本章是否存在剧情混乱、逻辑断层或矛盾等影响阅读体验的情况。`, //正文检测的提示词
            currectAnswerContent: '',//正文检测，只是用来替换内容
            currectAnswerText: '',//正文检测回答内容，ai
            content: '', //原正文内容
            requirement: '所有优化后的句子或段落采用加粗格式标注，便于快速定位修改点，确保校对成果清晰可查。',//要求
            currectLookContent: '',//只读，正文检测结果,ai
            currectContent: '',//可编辑，正文检测结果,ai
            placeholder: '请输入正文检测',
            streamIndex: 0, // 流式请求下标
            debounceTimer: null, // 防抖定时器
            typingTimer: null, // 打字效果定时器
            streamStatus: false, // 流式请求 false请求结束 true请求
            // streamLast: false, //流式最后一条
            novelId: '',//小说id
            chapter: '',//章节
            prevContent:'',//上一章的正文
            prevTitle:'',//上一章的标题
            title:'',//当前原文标题
            isStop: false,
        }
    },
    methods: {
        // 打开
        open(item) {
            this.showEditor = true
            this.activeName = '1'
            this.content = item.content
            this.novelId = item.novelId
            this.chapter = item.chapter
            this.prevContent = item.prevContent
            this.prevTitle = item.prevTitle
            this.title = item.title
        },
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        // 关闭
        closePopup() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.activeName = '1'
            this.content = ''
            this.currectAnswerText = ''
            this.currectContent = ''
            this.currectLookContent = ''
            this.novelId = ''
            this.chapter = ''
            this.prevContent = ''
            this.prevTitle = ''
            this.title = ''
            this.showEditor = false
        },
    }
}
</script>

<style lang="scss" scoped>
p {
    padding: 0;
    margin: 0;
}

#editor_trace {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_trace {
    height: 80% !important;
    width: 80%;
    background: #FFFFFF;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.editor_trace1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    height: 65px;
    padding: 0 30px;
    flex-shrink: 0;
    border-bottom: 1px solid #E6EBF0;

    img {
        width: 21px;
        height: 21px;
        cursor: pointer;
    }
}

.correct-main {
    flex: 1;
    width: 100%;
    display: flex;
    margin-top: 0 !important;
    overflow: auto;

    .correct-left {
        width: 50%;
        height: 100%;
        flex-shrink: 0;
        position: relative;
        display: flex;
        flex-direction: column;

        &::after {
            content: '';
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            border-right: 1px solid #E6EBF0;
        }

        .correct-title {
            flex-shrink: 0;
            height: 40px;
            flex-wrap: nowrap;
            display: flex;
            align-items: center;
            text-align: left;
            position: relative;
            padding: 0 15px;
            font-size: 16px;
            box-sizing: border-box;
            border-bottom: 1px solid #E6EBF0;
            cursor:default;
        }

    }

    .correct-right {
        flex: 1;
        display: flex;
        flex-direction: column;

        ::v-deep(.el-steps--simple) {
            // padding: 0;
            margin: 15px;
            height: 40px;
        }

        .correct-form {
            padding: 0 15px 15px;
        }

        ::v-deep(.el-tabs__nav-wrap) {
            &::after {
                height: 1px;
            }
        }

        .correct-form_zwjc {
            font-size: 16px;
            margin-bottom: 15px;
            margin-top: 15px;

            span {
                color: red;
            }
        }

        .editor_trace3_2 {
            margin: 0;
            width: 100%;
            height: auto;
            position: relative;

            ::v-deep(.el-textarea__inner) {
                @include scrollbar();

                &:hover {
                    @include scrollbar_hover();
                }
            }
        }

        .delimg {
            position: absolute;
            bottom: 10px;
            left: 10px;

        }

        .editor_trace3_3 {
            border: 0;
        }

        ::v-deep(.el-tabs) {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 100%;

            .el-tabs__header {
                margin: 0;
                padding: 0 15px;
            }

            .el-tabs__content {
                flex: 1;
                display: flex;
                flex-direction: column;
                // overflow: auto;
                @include scrollbar();

                &:hover {
                    @include scrollbar_hover();
                }
            }

            .el-tab-pane {
                flex: 1;
                height: 100%;
                display: flex;
                flex-direction: column;
            }
        }
    }

    .yhzw {
        margin: 0 15px;
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: auto;
        @include scrollbar();

        &:hover {
            @include scrollbar_hover();
        }

        ::v-deep(.stop) {
            position: sticky;
        }
    }

    .yw-title {
        padding: 0 15px !important;
    }

    .yw-content {
        flex: 1;
        padding: 15px;
        font-size: 16px;
        line-height: 1.8;
        overflow: auto;
        background-color: #FAFAFA;
        white-space: pre-wrap;
        @include scrollbar();

        &:hover {
            @include scrollbar_hover();
        }
    }

    .yhzw-content {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;

        ::v-deep(.el-textarea) {
            flex: 1;
            background-color: #FAFAFA;
        }

        ::v-deep(.el-textarea__inner) {
            // padding: 15px;
            height: 100%;
            border: 0;
            background-color: transparent;
            @include scrollbar();

            &:hover {
                @include scrollbar_hover();
            }
        }
    }

    ::v-deep(.el-input__count) {
        background-color: transparent;
    }
}
</style>